import { useTranslation } from 'react-i18next';

import { GraphChartConfigDto, TimelineChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import { useTimelineChartData } from 'hooks/useLineChartData';
import LineChart from 'components/Charts/LineChart/LineChart';

const TimelineChart = ({ chartData, isLoading, chartConfig }: ChartProps<TimelineChartDataDto, GraphChartConfigDto>) => {
  const { t } = useTranslation();

  const chartDataDisplay = useTimelineChartData(chartData?.datasets, isLoading);

  return <LineChart xLabel={''} yLabel={t(chartConfig.yAxis)} chartData={chartDataDisplay} />;
};

export default TimelineChart;
